import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePriceListItemExternalReferenceFragment = { readonly __typename?: 'SyncablePriceListItemExternalReference', readonly id: string, readonly itemId: string, readonly origin: Types.PriceableItemOrigin, readonly foreignId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncPriceListItemExternalReferencePullQueryVariables = Types.Exact<{
  input: Types.PullPriceListItemExternalReferenceInput;
}>;


export type SyncPriceListItemExternalReferencePullQuery = { readonly __typename?: 'Query', readonly pullPriceListItemExternalReference: { readonly __typename?: 'PullPriceListItemExternalReferenceResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePriceListItemExternalReference', readonly id: string, readonly itemId: string, readonly origin: Types.PriceableItemOrigin, readonly foreignId: string, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncablePriceListItemExternalReferenceFragmentDoc = gql`
    fragment WholeSyncablePriceListItemExternalReference on SyncablePriceListItemExternalReference {
  id
  itemId
  origin
  foreignId
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncPriceListItemExternalReferencePullDocument = gql`
    query SyncPriceListItemExternalReferencePull($input: PullPriceListItemExternalReferenceInput!) {
  pullPriceListItemExternalReference(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePriceListItemExternalReference
    }
  }
}
    ${WholeSyncablePriceListItemExternalReferenceFragmentDoc}`;

/**
 * __useSyncPriceListItemExternalReferencePullQuery__
 *
 * To run a query within a React component, call `useSyncPriceListItemExternalReferencePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPriceListItemExternalReferencePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPriceListItemExternalReferencePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPriceListItemExternalReferencePullQuery(baseOptions: Apollo.QueryHookOptions<SyncPriceListItemExternalReferencePullQuery, SyncPriceListItemExternalReferencePullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPriceListItemExternalReferencePullQuery, SyncPriceListItemExternalReferencePullQueryVariables>(SyncPriceListItemExternalReferencePullDocument, options);
      }
export function useSyncPriceListItemExternalReferencePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPriceListItemExternalReferencePullQuery, SyncPriceListItemExternalReferencePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPriceListItemExternalReferencePullQuery, SyncPriceListItemExternalReferencePullQueryVariables>(SyncPriceListItemExternalReferencePullDocument, options);
        }
export type SyncPriceListItemExternalReferencePullQueryHookResult = ReturnType<typeof useSyncPriceListItemExternalReferencePullQuery>;
export type SyncPriceListItemExternalReferencePullLazyQueryHookResult = ReturnType<typeof useSyncPriceListItemExternalReferencePullLazyQuery>;
export type SyncPriceListItemExternalReferencePullQueryResult = Apollo.QueryResult<SyncPriceListItemExternalReferencePullQuery, SyncPriceListItemExternalReferencePullQueryVariables>;